import { JSONApiRelation, JSONApiResourceBase } from '../interfaces/JSONApi.js'

export interface Dashboard extends JSONApiResourceBase {
  type: 'dashboards'
  attributes: {
    name?: string
    addToHomeScreen?: boolean
    loadAsPermission?: boolean
    config?: DashboardConfig
    exportOnly?: boolean
  }
  relationships: {
    organization: JSONApiRelation
  }
}

export enum VariableType {
  FREE_TYPE = 'FREE_TYPE',
  QUERY = 'QUERY',
  CUSTOM = 'CUSTOM',
  DATE = 'DATE',
  TIME = 'TIME',
}

export enum VisualizationType {
  TABLE = 'TABLE',
  SINGLE_STAT = 'SINGLE_STAT',
  HEADING = 'HEADING',
  TEXT = 'TEXT',
  CHART = 'CHART',
}

export interface Variable {
  id: string
  name: string
  label: string
  type?: VariableType
  data?: any
  variableConfig?: any
}

export interface DataVariable extends Variable {
  data: {
    query: string
    columns: {
      [column: string]: string
    }
  }
}

export interface FreeTypeVariable extends Variable {
  type: VariableType.FREE_TYPE
}
export interface DateVariable extends Variable {
  type: VariableType.DATE
}
export interface TimeVariable extends Variable {
  type: VariableType.TIME
}
export interface CustomVariable extends Variable {
  type: VariableType.CUSTOM
  variableConfig: {
    options: Array<string>
  }
}
export interface QueryVariable extends DataVariable {
  type: VariableType.QUERY
  variableConfig: {
    valueColumn?: string
    labelColumn?: string
    filterOnNull: boolean
  }
}

export type DashboardVariable =
  // | Variable
  | FreeTypeVariable
  | DateVariable
  | TimeVariable
  | CustomVariable
  | QueryVariable

export enum DashboardVariableMapType {
  NONE = 'None',
  FIXED = 'Fixed',
  VARMAP = 'VarMap',
  COLUMNMAP = 'ColumnMap',
}
export interface Panel {
  visualizationType: VisualizationType
  id: string
  x: number
  y: number
  w: number
  h: number
  i: number
  data: any
  visualizationConfig: any
}

export interface DataPanel extends Panel {
  data: {
    query: string
    columns: {
      [column: string]: string
    }
  }
}
export interface TablePanel extends DataPanel {
  visualizationType: VisualizationType.TABLE
  visualizationConfig: {
    columns: Array<{ column: string; label?: string }>
    isPaginated: boolean
    perPage: number
    preparedQuery: {
      usePreparedQuery: boolean
      preparedQueryName?: string
    }
  }
}

export interface ChartPanel extends DataPanel {
  visualizationType: VisualizationType.CHART
  visualizationConfig: {
    heading?: string
    type: ChartType
    labelColumn?: string
    valueColumn?: string
    groupLabelColumn?: string
  }
}

export enum ChartType {
  PIE = 'PIE',
  DOUGHNUT = 'DOUGHNUT',
  BAR = 'BAR',
  LINE = 'LINE',
}
export interface SingleStatPanel extends DataPanel {
  visualizationType: VisualizationType.SINGLE_STAT
  visualizationConfig: {
    statColumn?: string
    heading?: string
    preparedQuery?: {
      usePreparedQuery: boolean
      preparedQueryName?: string
    }
  }
}

export interface HeadingPanel extends Panel {
  visualizationType: VisualizationType.HEADING
  visualizationConfig: {
    size: string
    weight: string
    heading: string
  }
}

export type DashboardPanel =
  | TablePanel
  | SingleStatPanel
  | HeadingPanel
  | ChartPanel
export interface DashboardConfig {
  name: string
  interval?: number
  variables: Array<DashboardVariable>
  panels: Array<DashboardPanel>
  preparedQueries: Array<PreparedQueryConfig>
}

export interface PreparedQueryConfig {
  id: string
  name: string
  query: string
}
